import Component from './Share'
import withTranslations from './withTranslations'

export default withTranslations(Component)
